import { AnyAction } from 'redux';
import { App, Produkt, Produktlinie } from '@ps20-frontend/frontend-models';
import { produktReducer } from '@ps20-frontend/reducers';
import { ThhHundActions } from '../thhHundActions';

export const thhHundProduktReducer = function (
  sectionState: Produkt = null,
  action: AnyAction,
): Produkt {
  const newSectionState = produktReducer(sectionState, action, App.THH_HUND);
  switch (action.type) {
    case ThhHundActions.BRUTTOPREISE_CALCULATED: {
      const produktlinien: Produktlinie[] = action.payload;
      return { ...newSectionState, produktlinien };
    }
    default:
      return newSectionState;
  }
};
